<div class="timepicker-container">
  <h1 mat-dialog-title>{{ 'timepicker.title' | translate }}</h1>

  <div mat-dialog-content>
    <form class="timepicker-form">
      <mat-form-field>
        <mat-select [(ngModel)]="selectedHour" name="hour">
          <mat-option *ngFor="let h of hours" [value]="h">{{ h }}</mat-option>
        </mat-select>
      </mat-form-field>
      <span class="colon-separator">:</span>
      <mat-form-field>
        <mat-select [(ngModel)]="selectedMinute" name="minute">
          <mat-option *ngFor="let m of minutes" [value]="m">{{ m }}</mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </div>

  <div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="[selectedHour, selectedMinute, 0, 0]" cdkFocusInitial>
      {{ 'timepicker.actions.play' | translate | uppercase }}
    </button>
  </div>
</div>
